import React, { useContext, useState } from "react";
import {Formik, Form} from "formik";
import investigationSorter from "../../../utilities/investigations/investigationProcessor";
import InvestigationTypeBlock from './InvestigationTypeBlock.js'
import { Box, Paper, Button } from '@mui/material';
import "../../../css/report.css"
import { SymptomDetailsContext } from '../../../utilities/context.js'
import InvestigationExtraQuestionsModal from "./investigationextraquestionsmodal";


function Investigations(props){
    
    const {setIxList,} = useContext(SymptomDetailsContext) 
    let uniqueInvestigations=[...new Set(props.formData.investigations)]
    const [showAll, setShowAll]= useState(false)
    const investigations = investigationSorter()
    let initialValues= investigations
    let investigationsBlock=[]
    let key=0
    let allInvestigations=[]
    const [investigationExtraQuestionsModalOpen,setInvestigationExtraQuestionsModalOpen] =useState(false)
    const [investigationsForQuestions, setInvestigationsForQuestions] = useState([])
 

    for (let typeOfInvestigation in investigations)
        {
        let listOfInvestigations=Object.keys(investigations[typeOfInvestigation])
        investigationsBlock=<InvestigationTypeBlock typeOfInvestigation={typeOfInvestigation} listOfInvestigations={listOfInvestigations} NG12Investigations={uniqueInvestigations} showAll={showAll}
        initialValues={initialValues}
        key={key}/>
        allInvestigations.push(investigationsBlock)
        key ++
        }

    

    const onSubmit=(values)=>{
        setIxList(values)
      let investigationsForQuestionsAccumulator=[]
       for (let type in values)
        {
        for (let investigation in values[type])
            {
            if (values[type][investigation])
                {
                investigationsForQuestionsAccumulator.push(investigation)
                }
            }
            setInvestigationsForQuestions(investigationsForQuestionsAccumulator)
        }
    }
    

     const changeButton =()=>{setShowAll(showAll ? false : true)}

    let displayOption =((uniqueInvestigations.length===0  || showAll)  ? "hidden" :"investigationsBlock")
    return (
        <main>
        <Paper>
        <Button variant="outlined" onClick={changeButton}> {(showAll ? "Show NG12 recommended investigations" : "Show all available Investigations")} </Button>
        
        <Box id={displayOption}> NICE recommends considering the following investigations (see individual pathway recommendations above). Please note these may not be performed in secondary care if they are not relevant to a specialty you have made a two week referral to and you should therefore consider arranging these now. Select the investigations you feel are appropriate and  then CLICK ORDER INVESTIGATIONS
        </Box>
        
        <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}>
            
        <Form>
        <div id="allInvestigationsHolder">
        {allInvestigations}  

        </div>
        <Button variant="contained" size="large"  type="submit"> Order Investigations</Button>
        </Form>
        </Formik>
        </Paper>
       <InvestigationExtraQuestionsModal  investigationsForQuestions={investigationsForQuestions} modalOpen={investigationExtraQuestionsModalOpen} setModalOpen={setInvestigationExtraQuestionsModalOpen}/>
        </main >
        )
}

export default Investigations